import React, { useContext } from 'react'
import cx from 'classnames'

import ThemeContext from '@softwaredev_cegeka/stix-core/dist/components/ThemeProvider/ThemeContext'
import PrimaryButton from '@softwaredev_cegeka/stix-core/dist/components/Button/subcomponents/PrimaryButton'
import Grid from '@softwaredev_cegeka/stix-core/dist/components/Grid'

import fiveHundred from '../assets/images/500.svg'

export default function InternalServerError(props) {
    const theme = useContext(ThemeContext)
    const { themeImages } = theme

    return (
        <Grid.Container className={cx('page-body error-page', props.className)}>
            <h1 className={'error-title'}>Internal server error</h1>
            <h2 className={'error-status'}>500</h2>
            <div
                style={{
                    maxHeight: '50vh',
                    textAlign: 'center',
                }}
            >
                <img
                    style={{
                        maxHeight: '50vh',
                    }}
                    src={themeImages?.internalErrorImage ?? fiveHundred}
                    alt={'An error has occurred while processing your request.'}
                />
            </div>
            <div
                style={{
                    marginTop: '2rem',
                    textAlign: 'center',
                }}
            >
                <PrimaryButton
                    onClick={async () => {
                        await Promise.all(
                            (await caches.keys()).map(key => caches.delete(key))
                        )
                        window.location.reload()
                    }}
                >
                    Clear cache and refresh
                </PrimaryButton>
            </div>
        </Grid.Container>
    )
}
